import script from "./FondoInicio.vue?vue&type=script&setup=true&lang=js"
export * from "./FondoInicio.vue?vue&type=script&setup=true&lang=js"

import "./FondoInicio.vue?vue&type=style&index=0&id=11782b08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11782b08"]])

export default __exports__